import { Flex, View } from '@adobe/react-spectrum';
import { Paperclip } from 'react-bootstrap-icons';
import moment from 'moment';
import {
  truncateText,
  isOutgoingMessageForIcon,
} from '../../../../../utils/helperUtil';
import {
  DocumentIcon,
  InvoiceIcon,
  MailInCommingIcon,
  MailOutCommingIcon,
  MassmailGreen,
  NoticeIcon,
  PhoneInComingIcon,
  PhoneInOutGoingIcon,
  PhoneMissedIcon,
  TaskIcon,
} from '../../../../../components/protected/Icons/IconsLib';
import styles from './card_component.module.css';

interface IConceptCardComponentProps {
  item: any;
}

const ConceptCardComponent: React.FC<IConceptCardComponentProps> = ({ item }) => {
  const emailTypeImg = () => {
    switch (item.type) {
      case '1':
      case '12':
        return (
          <View UNSAFE_className={styles.email_type_img}>
            <NoticeIcon size={24} />
          </View>
        );
      case '2':
      case '3':
      case '7':
        if (isOutgoingMessageForIcon(item)) {
          return (
            <View UNSAFE_className={styles.email_type_img}>
              <MailOutCommingIcon size={24} />
            </View>
          );
        } else {
          return (
            <View UNSAFE_className={styles.email_type_img}>
              <MailInCommingIcon size={24} />
            </View>
          );
        }
      case '9':
      case '14':
      case '15':
      case '11':
        return (
          <View UNSAFE_className={styles.email_type_img}>
            <MailOutCommingIcon size={24} />
          </View>
        );
      case '4':
      case '5':
        return (
          <View UNSAFE_className={styles.email_type_img}>
            <DocumentIcon size={24} />
          </View>
        );
      case '6':
        if (item.status === '131072') {
          return (
            <View UNSAFE_className={styles.email_type_img}>
              <PhoneInComingIcon size={24} height={16} />
            </View>
          );
        } else if (item.status === '262144') {
          return (
            <View UNSAFE_className={styles.email_type_img}>
              <PhoneInOutGoingIcon size={24} height={16} />
            </View>
          );
        } else {
          return (
            <View UNSAFE_className={styles.email_type_img}>
              <PhoneMissedIcon size={24} height={16} />
            </View>
          );
        }
      // return (
      //   <View UNSAFE_className={styles.email_type_img}>
      //     <PhoneInComingIcon size={24} />
      //   </View>
      // );
      case '8':
        return (
          <View UNSAFE_className={styles.email_type_img}>
            <MassmailGreen size={24} />
          </View>
        );
      case '10':
        return (
          <View UNSAFE_className={styles.email_type_img}>
            <TaskIcon size={24} />
          </View>
        );
      case '13':
        return (
          <View UNSAFE_className={styles.email_type_img}>
            <InvoiceIcon size={24} />
          </View>
        );
    }
  };

  return (
    <View width={'340px'} position={'relative'} height={'81px'}>
      <Flex direction={'row'} position={'absolute'} top={'5px'} left={'50px'} alignItems={'center'} justifyContent={'start'} gap={'8px'} UNSAFE_className={styles.user_detail_parent}>
        <View position={'relative'} UNSAFE_className={item?.seen == '1' ? styles.user_name_read : styles.user_name_unread}>
          <span title={item?.templateName}>{truncateText(item?.templateName, 20)}</span>
        </View>
      </Flex>
      <View position={'absolute'} top={'27px'} left={'50px'} UNSAFE_className={item?.seen == '1' ? styles.email_subject_read : styles.email_subject_unread}>
        <span title={item?.subject}>{truncateText(item?.subject, 20)}</span>
      </View>
      <View position={'absolute'} top={'50px'} left={'50px'} width={'90px'} UNSAFE_className={styles.email_date}>
        {moment(item?.created).format('DD.MM.YYYY HH:mm')}
      </View>
      {emailTypeImg()}
    </View>
  );
};

export default ConceptCardComponent;
